import { FC } from 'react'

import './styles.scss'

export const Loader: FC = () => {
  return (
    <div className="loader-container">
      <img
        className="icon-loader"
        src={require('assets/images/loader.svg').default}
        alt="loader"
      />
    </div>
  )
}
